<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";
import GlobalLoadingScreen
    from "@/components/GlobalLoadingScreen/GlobalLoadingScreen.vue";
import AppUpdateBanner from "@/components/AppUpdateBanner/AppUpdateBanner.vue";
import { useAppBootstrap } from "@/composable/useAppBootstrap";
import { provideAppBreakpoint } from "@/composable/useAppBreakpoint";
import { LuvLocalizationWrapper } from "@polargold/luv-ui-library";
import { useAppLanguageStore } from "@/stores/appLanguageStore";

provideAppBreakpoint();

const appLanguageStore = useAppLanguageStore();

const appBootstrap = useAppBootstrap();

onMounted(() => appBootstrap.initialize());

onUnmounted(() => appBootstrap.dispose());
</script>

<template>
    <div>
        <GlobalLoadingScreen class="z-1000"/>
        <AppUpdateBanner/>
        <LuvLocalizationWrapper :language="appLanguageStore.languageCode">
            <router-view/>
        </LuvLocalizationWrapper>
    </div>
</template>
